export const TEAMS_AR = {
    
}